import { queryGraphQL } from 'common/util/query';
import { node, toQuery } from 'common/util/queryHelper';
import { addApplicationMessage, addApplicationMessages } from 'common/actions/applicationMessagesActions';

export const ACTIONS = {
    LOAD_MY_WORKFLOWS: 'LOAD_MY_WORKFLOWS',
    LOADING_MY_WORKFLOWS: 'LOADING_MY_WORKFLOWS',
    LOADING_PENDING_EVENTS: 'LOADING_PENDING_EVENTS',
    LOADING_COMPLETED_EVENTS: 'LOADING_COMPLETED_EVENTS',
    LOADING_PENDING_DOA: 'LOADING_PENDING_DOA',
    LOADING_COMPLETED_DOA: 'LOADING_COMPLETED_DOA',
    PENDING_EVENT_SIGNATURES_CREATED_BY_USER: 'PENDING_EVENT_SIGNATURES_CREATED_BY_USER',
    COMPLETED_EVENT_SIGNATURES_CREATED_BY_USER: 'COMPLETED_EVENT_SIGNATURES_CREATED_BY_USER',
    PENDING_DOA_SIGNATURES_CREATED_BY_USER: 'PENDING_DOA_SIGNATURES_CREATED_BY_USER',
    COMPLETED_DOA_SIGNATURES_CREATED_BY_USER: 'COMPLETED_DOA_SIGNATURES_CREATED_BY_USER',
    UNLOAD_SENTBOX: 'UNLOAD_SENTBOX',
};

export function getSentboxDetails(){
    return async (dispatch) => {
        dispatch(loadMyWorkflows());
        dispatch(loadPendingEventTasksCreatedByUser());
        dispatch(loadCompletedEventTasksCreatedByUser());
        dispatch(loadPendingDOATasksCreatedByUser());
        dispatch(loadCompletedDOATasksCreatedByUser());
    };
}


export function loadingMyWorkflows(loading){
    return {
        type: ACTIONS.LOADING_MY_WORKFLOWS,
        payload: loading
    };
}

export function unloadSentbox(){
    return {
        type: ACTIONS.UNLOAD_SENTBOX
    };
}

export function loadingPendingEventTasks(loading){
    return {
        type: ACTIONS.LOADING_PENDING_EVENTS,
        payload: loading
    };
}

export function loadingCompletedEventTasks(loading) {
    return {
        type: ACTIONS.LOADING_COMPLETED_EVENTS,
        payload: loading
    };
}

export function loadingPendingDOATasks(loading){
    return {
        type: ACTIONS.LOADING_PENDING_DOA,
        payload: loading
    };
}

export function loadingCompletedDOATasks(loading) {
    return {
        type: ACTIONS.LOADING_COMPLETED_DOA,
        payload: loading
    };
}

export function loadMyWorkflows() {
    loadingMyWorkflows(true);
    const query = toQuery(node('myWorkflows', [
        'id',
        'title',
        'author',
        'authorDisplayName',
        'shortDescription',
        'actionName',
        'sentDate',
        'dueDate',
        'endDate',
        'status',
        'documentId',
        'totalInstances',
        'activeInstances',
        'completedInstances',
        'binderId',
        node('recipients', [
            'displayName',
            'id',
            'sub',
        ]),
        node('tasks', [
            'finished',
            'deleted',
            'assignee',
            'taskDefinitionKey',
            'name',
        ]),
        node('document', [
            'institutionId',
            node('documentType', [
                'displayName',
            ])
        ])
    ]));

    return async dispatch => {
        const results = await queryGraphQL(query);
        if(results.errors) {
            dispatch(addApplicationMessages('error', results.formattedErrors));
        }else{
            
            dispatch({
                type: ACTIONS.LOAD_MY_WORKFLOWS,
                payload : results.data.myWorkflows
            });
        }
        loadingMyWorkflows(false);
    };
}

export function loadPendingEventTasksCreatedByUser(){
    return async dispatch => {
        dispatch(loadingPendingEventTasks(true));
        const query = node('me', [
            node('createdPendingEventSignatures',[
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('event', [
                    'id',
                    'eventType',
                    'binderId',
                    'institutionId',
                ]),
                'sentDate'
            ])
        ]);

        const response = await queryGraphQL(toQuery(query));
        if(response.errors){
            dispatch(addApplicationMessage('error', 'Failed to load pending event tasks. Please try again'));
        }
        else {
            dispatch({
                type: ACTIONS.PENDING_EVENT_SIGNATURES_CREATED_BY_USER,
                payload: response.data.me.createdPendingEventSignatures
            });
        }

        dispatch(loadingPendingEventTasks(false));
    };
}

export function loadCompletedEventTasksCreatedByUser(){
    return async dispatch => {
        dispatch(loadingCompletedEventTasks(true));
        const query = node('me', [
            node('createdCompleteEventSignatures',[
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('event', [
                    'id',
                    'eventType',
                    'binderId',
                    'institutionId',
                ]),
                'sentDate',
                'signedDate'
            ])
        ]);

        const response = await queryGraphQL(toQuery(query));
        if(response.errors){
            dispatch(addApplicationMessage('error', 'Failed to load completed event tasks. Please try again'));
        }
        else {
            dispatch({
                type: ACTIONS.COMPLETED_EVENT_SIGNATURES_CREATED_BY_USER,
                payload: response.data.me.createdCompleteEventSignatures
            });
        }

        dispatch(loadingCompletedEventTasks(false));
    };
}

export function loadPendingDOATasksCreatedByUser() {
    return async dispatch => {
        dispatch(loadingPendingDOATasks(true));
        const query = node('me', [
            node('createdPendingDOASignatures',[
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('delegation', [
                    'id',
                    node('user', [
                        'id',
                        'displayName',
                        'emailAddress',
                    ]),
                    node('rolesManagement', [
                        'id',
                        'name'
                    ]),
                    'taskIds',
                    'startDate',
                    'endDate',
                ]),
                'sentDate',
                'binderName',
            ])
        ]);

        const response = await queryGraphQL(toQuery(query));
        if(response.errors){
            dispatch(addApplicationMessage('error', 'Failed to load pending DOA tasks. Please try again'));
        }
        else {
            dispatch({
                type: ACTIONS.PENDING_DOA_SIGNATURES_CREATED_BY_USER,
                payload: response.data.me.createdPendingDOASignatures,
            });
        }

        dispatch(loadingPendingDOATasks(false));
    };
}

export function loadCompletedDOATasksCreatedByUser() {
    return async dispatch => {
        dispatch(loadingCompletedEventTasks(true));
        const query = node('me', [
            node('createdCompleteDOASignatures',[
                'id',
                'status',
                node('requestedFrom', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('createdBy', [
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                node('delegation', [
                    'id',
                    node('user', [
                        'id',
                        'displayName',
                        'emailAddress',
                    ]),
                    node('rolesManagement', [
                        'id',
                        'name'
                    ]),
                    'taskIds',
                    'startDate',
                    'endDate',
                ]),
                'sentDate',
                'signedDate',
                'binderName',
            ])
        ]);

        const response = await queryGraphQL(toQuery(query));
        if(response.errors){
            dispatch(addApplicationMessage('error', 'Failed to load completed DOA tasks. Please try again'));
        }
        else {
            dispatch({
                type: ACTIONS.COMPLETED_DOA_SIGNATURES_CREATED_BY_USER,
                payload: response.data.me.createdCompleteDOASignatures
            });
        }

        dispatch(loadingCompletedDOATasks(false));
    };
}
